var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "q-if row no-wrap relative-position q-input q-if-inverted q-if-inverted-light q-if-has-content bg-white text-black no-shadow generic-border"
    },
    [
      _c("div", { staticClass: "q-if-inner col column" }, [
        _c(
          "div",
          { staticClass: "row no-wrap relative-position items-center" },
          [
            _c("cleave", {
              staticClass: "col q-input-target q-no-input-spinner ellipsis",
              attrs: {
                placeholder: "-",
                options: {
                  time: true,
                  timePattern: ["h", "m"]
                }
              },
              on: { input: _vm.handleInput },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            }),
            _vm.date
              ? _c(
                  "span",
                  {
                    staticClass: "text-light cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.$emit("clickDate")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.dateFormatted) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }